var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg165Menu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438,0H74C33.196,0,0,33.196,0,74s33.196,74,74,74h364c40.804,0,74-33.196,74-74S478.804,0,438,0z M438,108H74 c-18.748,0-34-15.252-34-34s15.252-34,34-34h364c18.748,0,34,15.252,34,34S456.748,108,438,108z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438,182H74c-40.804,0-74,33.196-74,74s33.196,74,74,74h364c40.804,0,74-33.196,74-74S478.804,182,438,182z M438,290H74 c-18.748,0-34-15.252-34-34s15.252-34,34-34h364c18.748,0,34,15.252,34,34S456.748,290,438,290z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438,364H74c-40.804,0-74,33.196-74,74s33.196,74,74,74h264c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20H74 c-18.748,0-34-15.252-34-34s15.252-34,34-34h364c18.748,0,34,15.252,34,34s-15.252,34-34,34c-11.046,0-20,8.954-20,20 c0,11.046,8.954,20,20,20c40.804,0,74-33.196,74-74S478.804,364,438,364z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg165Menu);
export default __webpack_public_path__ + "static/media/165-menu.58a18ba6649ed21e41ce66d949efe6e2.svg";
export { ForwardRef as ReactComponent };